module.exports = __webpack_public_path__ + "static/media/logo150.531b7a0f.png";